import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as DashboardImg} from '../../assets/chat06/dashboard.svg';
import {ReactComponent as DashboardSmallImg} from '../../assets/chat06/dashboard-sm.svg';
import {ReactComponent as DashboardMediumImg} from '../../assets/chat06/dashboard-md.svg';
import {ReactComponent as DashboarLargedImg} from '../../assets/chat06/dashboard-lg.svg';
import {ReactComponent as SmileImg} from '../../assets/chat06/smile.svg';
import {ReactComponent as TutorialImg} from '../../assets/chat06/tutorial.svg';
import {ReactComponent as TutorialSmallImg} from '../../assets/chat06/tutorial-sm.svg';
import {ReactComponent as TutorialMediumImg} from '../../assets/chat06/tutorial-md.svg';
import {ReactComponent as TutorialLargeImg} from '../../assets/chat06/tutorial-lg.svg';

export default function Chat06() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const mobileLarge = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    const getDashboardImg = () => {
        if (mobileSmall) return DashboardSmallImg;
        if (mobileMedium) return DashboardMediumImg;
        if (mobileLarge) return DashboarLargedImg;

        return DashboardImg;
    };

    const getTutorialImg = () => {
        if (mobileSmall) return TutorialSmallImg;
        if (mobileMedium) return TutorialMediumImg;
        if (mobileLarge) return TutorialLargeImg;

        return TutorialImg;
    };

    const dataMap = [
        { 
            type: 'dashboard',
            title: '사용자용 대시보드',
            subTitle: mobileMedium ? <>업데이트되는 정보들을 통해 활용성을<br />높여드려요</> : '업데이트되는 정보들을 통해 활용성을 높여드려요',
            Image: getDashboardImg()
        },
        { 
            type: 'tutorial',
            title: '튜토리얼',
            subTitle: '즐거운 튜토리얼과 함께 시작해 봐요',
            Image: getTutorialImg()
        }
    ];

    return (
        <FeatureCardBox
            type='etc'
            IconImage={SmileImg}
            keyword='사용자를 위한 기능'
            title={mobileSmall ? <>처음부터 능숙하게 사용<br />가능하도록 도와줄게요!</> : '처음부터 능숙하게 사용 가능하도록 도와줄게요!'}
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
        />
    );
}
